/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OAuth2DTO
 */
export interface OAuth2DTO {
    /**
     * 
     * @type {string}
     * @memberof OAuth2DTO
     */
    clientId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OAuth2DTO
     */
    authority?: string | null;
}

/**
 * Check if a given object implements the OAuth2DTO interface.
 */
export function instanceOfOAuth2DTO(value: object): value is OAuth2DTO {
    return true;
}

export function OAuth2DTOFromJSON(json: any): OAuth2DTO {
    return OAuth2DTOFromJSONTyped(json, false);
}

export function OAuth2DTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuth2DTO {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
        'authority': json['authority'] == null ? undefined : json['authority'],
    };
}

export function OAuth2DTOToJSON(json: any): OAuth2DTO {
    return OAuth2DTOToJSONTyped(json, false);
}

export function OAuth2DTOToJSONTyped(value?: OAuth2DTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'authority': value['authority'],
    };
}

